import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Navbar,
  NavItem,
  Nav,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import _ from "lodash";

import { Intl, LinkLegal } from "components";
// import logo from "assets/img/brand/massphoning-in.svg";
import fetaveLogo from "assets/img/brand/EasyCall-in-logo.svg";
import UserActions from "store/reducers/User";

const MainNavbar = React.memo(
  ({
    sidebarCollapsed,
    toggleSidenav,
    logoutUser,
    pathname,
    routes,
    accountName,
    accountId,
    user,
    locale,
  }) => {
    const isActive = (route) =>
      route.layout + route.path === "/"
        ? pathname === "/"
        : pathname.indexOf(route.layout + route.path) === 0;

    const isAdmin =
      user &&
      _.findIndex(user.roles, (r) => r.toUpperCase().indexOf("ADMIN") >= 0) >=
        0;

    return (
      <>
        <Navbar className="navbar-top main-navbar navbar-expand navbar-horizontal d-flex flex-column">
          <Row noGutters className="w-100 pt-3">
            <Col className="text-right">
              {!!accountId && (
                <span className="text-sm text-mp-orange-1">
                  {accountName ? accountName.toUpperCase() : accountName}
                  {" - "}
                  {_.get(user, "firstName", "")} {_.get(user, "lastName", "")}
                  {" | "}
                </span>
              )}
              {isAdmin ? (
                <UncontrolledDropdown>
                  <DropdownToggle caret color="link" className="px-0 m-0">
                    <i className="app-icon-users-2" />
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem>
                      <Link to="/in/profile" className="text-sm d-block">
                        <Intl id="profile" />
                      </Link>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem>
                      <span className="text-sm cursor-pointer d-block text-mp-orange-1">
                        <LinkLegal
                          label="legalInformation"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={{
                            es: "https://easycall.es/legal",
                            en: "https://easycall.es/legal",
                          }}
                        />
                      </span>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem>
                      <span
                        className="text-sm cursor-pointer d-block text-mp-orange-1"
                        onClick={logoutUser}
                      >
                        <Intl id="logout" />
                      </span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              ) : (
                <span
                  className="text-sm cursor-pointer lh-39"
                  onClick={logoutUser}
                >
                  <Intl id="logout" />
                </span>
              )}
            </Col>
          </Row>

          <Row noGutters className="w-100 h-100 align-items-center">
            <Col md="auto">
              <div>
                <Nav className="align-items-center" navbar>
                  <NavItem className="d-sm-none">
                    <div
                      className={classnames("pr-3 sidenav-toggler", {
                        active: !sidebarCollapsed,
                      })}
                      onClick={toggleSidenav}
                    >
                      <div className="sidenav-toggler-inner ml-2">
                        <i className="sidenav-toggler-line" />
                        <i className="sidenav-toggler-line" />
                        <i className="sidenav-toggler-line" />
                      </div>
                    </div>
                  </NavItem>
                </Nav>

                <Link to="/in/answering" className="d-none d-sm-flex main-logo">
                  <img alt="Massphoning" src={fetaveLogo} />
                </Link>
              </div>
            </Col>
            <Col md>
              <div className="d-none d-md-flex pr-2 justify-content-end flex-wrap">
                {_.map(routes, (route) =>
                  route.notShowTopbar ? null : (
                    <Link
                      key={route.name}
                      to={route.layout + route.path}
                      className={classnames("nav-link", {
                        active: isActive(route),
                        disabled:
                          !isAdmin && route.path.indexOf("administration") >= 0,
                      })}
                      onClick={(e) => {
                        if (
                          !isAdmin &&
                          route.path.indexOf("administration") >= 0
                        ) {
                          e.preventDefault();
                        }
                      }}
                    >
                      <Intl id={route.name} />
                    </Link>
                  )
                )}
                <a
                  className="nav-link"
                  href={
                    _.get(locale, "locale") === "es"
                      ? "https://easycall.es/ayuda"
                      : "https://easycall.es/ayuda"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-question-circle" />
                </a>
              </div>
            </Col>
          </Row>
        </Navbar>
      </>
    );
  }
);

MainNavbar.defaultProps = {
  toggleSidenav: () => {},
  sidebarCollapsed: false,
};

MainNavbar.propTypes = {
  toggleSidenav: PropTypes.func,
  sidebarCollapsed: PropTypes.bool,
};

const mapStateToProps = ({ account, user, settings }) => ({
  user,
  accountName: account.name,
  accountId: account.id,
  locale: settings.locale,
});

const mapDispatchToProps = {
  logoutUser: UserActions.logoutUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainNavbar);
